/**
 * 聚水潭 ERP 第三章「创建售后」场景，素材对应《聚水潭功能学习》PPT 第 38-45 页。
 */

import receiverProvinces from '../../../../static/json/jst-provinces.json'
import receiverCities from '../../../../static/json/jst-cities.json'
import receiverDistricts from '../../../../static/json/jst-districts.json'
import {
  JST_TARGETS,
  JST_CREATE_ORDER,
  JST_CREATE_GOODS,
  JST_PRODUCT_LIBRARY_GOODS,
  JST_ERROR_PRODUCT
} from './jstErpFixtureData'
import { br, red } from './jstTip'

function r(path) {
  return require('@/assets/images/jushuitan/' + path)
}

const TARGET_ORDER_CODE = JST_TARGETS.createAftersaleOrder
const DETAIL_ORDER_CODE = '331273354843811187'
const TARGET_PRACTICE_GOODS_CODE = JST_CREATE_GOODS[0].goodsCode
const TARGET_PRACTICE_STYLE_CODE = JST_CREATE_GOODS[0].styleCode
const DOMESTIC_EXPRESS_COMPANIES = [
  'EMS', '邮政快递包裹', '顺丰速运', '顺丰同城', '京东快递', '中通快递', '圆通速递', '申通快递', '韵达快递', '极兔速递',
  '德邦快递', '菜鸟速递', '百世快递'
]
const DIRECT_CONTROLLED_MUNICIPALITIES = ['北京市', '天津市', '上海市', '重庆市']

function findReceiverProvince(provinceName) {
  return receiverProvinces.find(item => item.name === provinceName)
}

function getReceiverCities(provinceName) {
  const province = findReceiverProvince(provinceName)
  if (!province) return []
  if (DIRECT_CONTROLLED_MUNICIPALITIES.indexOf(provinceName) > -1) return [provinceName]
  return receiverCities.filter(item => item.province === province.province).map(item => item.name)
}

function getReceiverDistricts(provinceName, cityName) {
  const province = findReceiverProvince(provinceName)
  if (!province || !cityName) return []
  if (DIRECT_CONTROLLED_MUNICIPALITIES.indexOf(provinceName) > -1) {
    return receiverDistricts.filter(item => item.province === province.province).map(item => item.name)
  }
  const city = receiverCities.find(item => item.province === province.province && item.name === cityName)
  return city ? receiverDistricts.filter(item => item.province === province.province && item.city === city.city).map(item => item.name) : []
}

const SCENE_IMAGES = {
  aftersaleList: r('ppt/2-22-已创建手工售后单.png'),
  empty: r('3-1-create-aftersale-empty.png'),
  return: r('3-2-create-aftersale-return.png'),
  refund: r('3-3-create-aftersale-refund.png'),
  resend: r('3-leak-resend-selected.png'),
  detail: r('3-5-aftersale-detail.png'),
  noInfo: r('3-noinfo-aftersale.png'),
  goods: r('3-noinfo-product-library.png')
}

const ORDER_FIELD = {
  id: 'order-code', model: 'orderCode', type: 'text', bgColor: '#fff', fontSize: 11,
  placeholder: '线上订单号', x: 0.132, y: 0.093, w: 0.077, h: 0.021
}

const PRACTICE_ORDER = JST_CREATE_ORDER
const DETAIL_PRACTICE_ORDER = { ...PRACTICE_ORDER, onlineOrderNo: DETAIL_ORDER_CODE }
const PRACTICE_GOODS = JST_CREATE_GOODS
const THIRD_CHAPTER_TIPS = [
  '线上订单号' + red('3312733548438011187') + '关联的商品' + red('TEST-GD-0003') + '破损，卖家需补发。买家已经使用' + red('申通快递') + '退回' + red('淘金仓库') + '，单号' + red('st12654458855') + '，花费' + red('8元') + '。' + br() + '补发商品卖家将使用' + red('京东快递') + '由' + red('淘金仓库') + '寄出，买家手机地址为：' + red('陕西省西安市雁塔区丈八街道丹轩梓园3号楼，收货人朱小明、13800138000'),
  '线上订单号 ' + red('3312733548438011187') + '关联的商品' + red('TEST-GD-0001') + '未发，错发了商品' + red('STY-BSK-001') + '。' + br() + '买家已使用' + red('申通快递') + '，自担' + red('8元') + '运费退回错发商品，' + red('st12654458855') + '，退回' + red('淘金仓库') + '。买家退款账号为 ' + red('13800138000') + '，卖家退款账号为' + red('淘金账户') + '。',
  '线上订单号' + red('3312733548438011187') + '关联商品 ' + red('TEST-GD-0003') + ' 涉及' + red('错发退换货') + '。买家已使用' + red('申通快递') + '退回' + red('淘金仓库') + '，退回单号 ' + red('st12654458855') + '，退货运费 ' + red('8元') + '，买家退款账号为 ' + red('13800138000') + '，卖家退款账号为' + red('淘金账户') + '。' + br() + '卖家需补发订单原商品 ' + red('TEST-GD-0003') + '，错发已发商品为 ' + red('STY-PLT-001') + '。买家收货地址为：' + red('陕西省西安市雁塔区丈八街道丹轩梓园3号楼') + '，收货人' + red('朱小明') + '，联系手机 ' + red('13800138000') + '。补发商品卖家将使用' + red('京东快递') + '寄出，备注为“' + red('错发退换货') + '”。',
  '线上订单号 ' + red('3312733548438011187') + '关联商品 ' + red('TEST-GD-0003') + ' 漏发，卖家需补发 ' + red('1件') + '。' + br() + '补发商品由卖家使用' + red('京东快递') + '从' + red('淘金仓库') + '寄出。买家收货地址为：' + red('陕西省西安市雁塔区丈八街道丹轩梓园3号楼') + '；收货人：' + red('朱小明') + '；联系电话：' + red('13800138000') + '。',
  '登记无信息件商品' + red('STY-PLT-001') + '退回' + br() + '买家退回快递公司：' + red('申通快递') + br() + '买家退回快递单号：' + red('st12654458855') + br() + '退回仓库：' + red('淘金仓库') + br() + '售后店铺：' + red('淘金云官方旗舰店')
]
const THIRD_CHAPTER_DETAIL_TIP = '查询线上订单' + red(DETAIL_ORDER_CODE) + '的售后明细'

function getThirdChapterTip({ ui }) {
  const createdCount = (ui.createdThirdAftersales || []).length
  return createdCount >= THIRD_CHAPTER_TIPS.length
    ? THIRD_CHAPTER_DETAIL_TIP
    : THIRD_CHAPTER_TIPS[createdCount]
}

function requirePracticeOrderSelection({ ui }) {
  return (ui['third-practice-order-tableSelectedKeys'] || []).includes(PRACTICE_ORDER.id)
    ? { ok: true }
    : { ok: false, msg: '请先选中搜索出的订单' }
}

const CLEAR_PRACTICE_ORDER_SELECTION = {
  'third-practice-order-tableSelectedKeys': [],
  'third-practice-order-tableSelectedRows': [],
  'third-practice-goods-tableSelectedKeys': [],
  'third-practice-goods-tableSelectedRows': [],
  'third-practice-goods-tableRowDrafts': {}
}

function buildPracticeOrderTables(goodsType, ui = {}, practiceOrder = PRACTICE_ORDER) {
  const orderSelected = (ui['third-practice-order-tableSelectedKeys'] || []).includes(PRACTICE_ORDER.id)
  const selectedKeys = ui['third-practice-goods-tableSelectedKeys'] || []
  const selectedRows = ui['third-practice-goods-tableSelectedRows'] || []
  const rowDrafts = ui['third-practice-goods-tableRowDrafts'] || {}
  const rows = PRACTICE_GOODS.map(row => {
    const changed = selectedRows.find(item => item.id === row.id)
    return { ...row, ...changed, ...(rowDrafts[row.id] || {}), type: goodsType }
  })
  return [
    {
      id: 'third-practice-order-table',
      x: 0.045, y: 0.12, w: 0.94, h: 0.365,
      fontSize: 10,
      rows: [practiceOrder],
      columns: [
        { key: 'internalOrderNo', title: '内部订单号', width: 126 },
        { key: 'orderDate', title: '订单日期', width: 150 },
        { key: 'buyerAccount', title: '买家账号', width: 100 },
        { key: 'shop', title: '店铺', width: 125 },
        { key: 'status', title: '状态', width: 90 },
        { key: 'onlineOrderNo', title: '线上订单号', width: 180 },
        { key: 'receivableAmount', title: '应付金额', width: 90, align: 'right' },
        { key: 'paidAmount', title: '已付金额', width: 90, align: 'right' },
        { key: 'freight', title: '运费', width: 70, align: 'right' },
        { key: 'orderType', title: '订单类型', width: 100 },
        { key: 'receiver', title: '收货人', width: 100 },
        { key: 'buyerMessage', title: '买家留言', width: 110 },
        { key: 'phone', title: '手机', width: 120 },
        { key: 'address', title: '收货地址', width: 210 },
        { key: 'expressCompany', title: '快递公司', width: 100 },
        { key: 'expressNo', title: '快递单号', width: 150 },
        { key: 'orderRemark', title: '订单备注', width: 110 }
      ],
      rowKey: 'id',
      selectable: true,
      selectionType: 'radio',
      selectedKeys: []
    },
    {
      id: 'third-practice-goods-table',
      x: 0.045, y: 0.715, w: 0.94, h: 0.23,
      fontSize: 10,
      rows: orderSelected ? rows : [],
      columns: [
        { key: 'thumbnail', type: 'image', title: '缩略图', width: 68 },
        { key: 'goodsCode', title: '商品编码', width: 140 },
        { key: 'styleCode', title: '款式编码', width: 110 },
        { key: 'type', title: '类型', width: 58 },
        { key: 'goodsName', title: '商品名称', width: 210 },
        { key: 'spec', title: '颜色及规格', width: 160 },
        { key: 'orderGoodsStatus', title: '订单商品状态', width: 120 },
        { key: 'goodsTag', title: '商品标签', width: 100 },
        { key: 'unitPrice', type: 'input', title: '单价', width: 88, align: 'right' },
        { key: 'goodsAmount', title: '商品金额', width: 100, align: 'right' },
        { key: 'orderQty', title: '订单数量', width: 88, align: 'right' },
        { key: 'currentQty', type: 'input', title: '本次数量', width: 88, align: 'right' },
        { key: 'defectiveQty', title: '次品数量', width: 88, align: 'right' },
        { key: 'currentAmount', type: 'input', title: '本次金额', width: 100, align: 'right' },
        { key: 'appliedReturnQty', title: '已申请退货', width: 100, align: 'right' },
        { key: 'actualReturnQty', title: '实退退货', width: 100, align: 'right' },
        { key: 'remark', type: 'input', title: '备注', width: 160 },
        { key: 'availableStock', title: '可用库存', width: 88, align: 'right' }
      ],
      rowKey: 'id',
      selectable: true,
      selectedKeys,
      onCellChange: ({ row, key, value, ui, setUi }) => {
        const drafts = { ...(ui['third-practice-goods-tableRowDrafts'] || {}) }
        drafts[row.id] = { ...(drafts[row.id] || {}), [key]: value }
        setUi({ 'third-practice-goods-tableRowDrafts': drafts })
      }
    }
  ]
}

function buildLeakResendOrderTables(ui = {}) {
  const [orderTable, baseGoodsTable] = buildPracticeOrderTables('补', ui)
  const selectedKeys = ui['third-leak-resend-goods-tableSelectedKeys'] || []
  const selectedRows = ui['third-leak-resend-goods-tableSelectedRows'] || []
  const rowDrafts = ui['third-leak-resend-goods-tableRowDrafts'] || {}
  const rows = PRACTICE_GOODS.map(row => {
    const changed = selectedRows.find(item => item.id === row.id)
    return { ...row, ...changed, ...(rowDrafts[row.id] || {}), type: '补' }
  })
  const isSelected = row => selectedKeys.indexOf(row.id) > -1
  const columns = baseGoodsTable.columns.map(column => {
    if (column.key === 'type') return { ...column, type: 'badge', width: 58 }
    if (column.key === 'currentQty') return { ...column, inputDisabled: row => !isSelected(row) }
    return column
  })
  columns.splice(4, 0, {
    key: 'issueType', type: 'select', title: '明细问题类型', width: 130,
    options: ['应发未发'], inputDisabled: row => !isSelected(row)
  })
  return [orderTable, {
    ...baseGoodsTable,
    id: 'third-leak-resend-goods-table',
    rows,
    columns,
    selectedKeys,
    onCellChange: ({ row, key, value, ui, setUi }) => {
      const drafts = { ...(ui['third-leak-resend-goods-tableRowDrafts'] || {}) }
      drafts[row.id] = { ...(drafts[row.id] || {}), [key]: value }
      setUi({ 'third-leak-resend-goods-tableRowDrafts': drafts })
    }
  }]
}

function buildWrongReturnOrderTables(ui = {}) {
  const [orderTable] = buildPracticeOrderTables('退', ui)
  const orderSelected = (ui['third-practice-order-tableSelectedKeys'] || []).includes(PRACTICE_ORDER.id)
  const rows = [{
    ...PRACTICE_GOODS[0],
    id: 'wrong-return-goods-1',
    type: '退',
    issueType: '',
    currentQty: 0,
    currentAmount: 0
  }].concat(ui.wrongReturnAddedGoods || [])
  return [
    orderTable,
    ...(orderSelected ? [{
      id: 'third-wrong-return-goods-table',
      x: 0.045, y: 0.715, w: 0.94, h: 0.23,
      fontSize: 10,
      rows,
      columns: [
        { key: 'thumbnail', type: 'image', title: '缩略图', width: 68 },
        { key: 'goodsCode', title: '商品编码', width: 140 },
        { key: 'styleCode', title: '款式编码', width: 110 },
        { key: 'type', title: '类型', width: 58 },
        { key: 'issueType', title: '明细问题类型', width: 130 },
        { key: 'goodsName', title: '商品名称', width: 210 },
        { key: 'spec', title: '颜色及规格', width: 160 },
        { key: 'orderGoodsStatus', title: '订单商品状态', width: 120 },
        { key: 'goodsTag', title: '商品标签', width: 100 },
        { key: 'unitPrice', title: '单价', width: 88, align: 'right' },
        { key: 'goodsAmount', title: '商品金额', width: 100, align: 'right' },
        { key: 'orderQty', title: '订单数量', width: 88, align: 'right' },
        { key: 'currentQty', title: '本次数量', width: 88, align: 'right' },
        { key: 'defectiveQty', title: '次品数量', width: 88, align: 'right' },
        { key: 'currentAmount', title: '本次金额', width: 100, align: 'right' },
        { key: 'appliedReturnQty', title: '已申请退货', width: 100, align: 'right' },
        { key: 'actualReturnQty', title: '实退退货', width: 100, align: 'right' },
        { key: 'remark', title: '备注', width: 160 },
        { key: 'availableStock', title: '可用库存', width: 88, align: 'right' }
      ],
      rowKey: 'id',
      selectable: true
    }] : [])
  ]
}

const WRONG_EXCHANGE_GOODS = [
  {
    ...PRACTICE_GOODS[0],
    id: 'wrong-exchange-goods-1',
    type: '退',
    issueType: ''
  },
  {
    ...PRACTICE_GOODS[1],
    id: 'wrong-exchange-goods-2',
    type: '退',
    issueType: ''
  }
]

const PRODUCT_LIBRARY_GOODS = JST_PRODUCT_LIBRARY_GOODS
const TARGET_LIBRARY_GOODS = PRODUCT_LIBRARY_GOODS[0]
const TARGET_LIBRARY_STYLE_CODE = TARGET_LIBRARY_GOODS.styleCode
const TARGET_LIBRARY_GOODS_CODE = TARGET_LIBRARY_GOODS.goodsCode
const WRONG_RETURN_LIBRARY_PRODUCT = {
  id: 'wrong-return-library-sty-bsk-001',
  styleCode: JST_ERROR_PRODUCT.styleCode,
  goodsCode: JST_ERROR_PRODUCT.goodsCode,
  goodsName: JST_ERROR_PRODUCT.goodsName,
  spec: JST_ERROR_PRODUCT.spec,
  unitPrice: JST_ERROR_PRODUCT.price,
  stock: 48
}
const WRONG_RETURN_ADDED_GOOD = {
  id: 'wrong-return-added-wrong-goods-1',
  thumbnail: '',
  goodsCode: WRONG_RETURN_LIBRARY_PRODUCT.goodsCode,
  styleCode: WRONG_RETURN_LIBRARY_PRODUCT.styleCode,
  type: '退',
  issueType: '错发已发',
  goodsName: WRONG_RETURN_LIBRARY_PRODUCT.goodsName,
  spec: WRONG_RETURN_LIBRARY_PRODUCT.spec,
  orderGoodsStatus: '',
  goodsTag: '',
  unitPrice: WRONG_RETURN_LIBRARY_PRODUCT.unitPrice,
  goodsAmount: WRONG_RETURN_LIBRARY_PRODUCT.unitPrice,
  orderQty: 1,
  currentQty: '1',
  defectiveQty: '',
  currentAmount: WRONG_RETURN_LIBRARY_PRODUCT.unitPrice,
  appliedReturnQty: 0,
  actualReturnQty: 0,
  remark: '',
  availableStock: WRONG_RETURN_LIBRARY_PRODUCT.stock
}

function pickerColumns() {
  return [
    { key: 'goodsCode', title: '商品编码', width: 160 },
    { key: 'styleCode', title: '款式编码', width: 120 },
    { key: 'goodsName', title: '商品名称', width: 220 },
    { key: 'spec', title: '颜色及规格', width: 160 },
    { key: 'orderQty', title: '数量', width: 70, align: 'right' },
    { key: 'unitPrice', title: '单价', width: 80, align: 'right' },
    { key: 'goodsAmount', title: '金额', width: 80, align: 'right' }
  ]
}

function buildOrderGoodsPicker(id, selectedKeys, layout = {}) {
  return [{
    id,
    x: layout.x === undefined ? 0.3 : layout.x,
    y: layout.y === undefined ? 0.31 : layout.y,
    w: layout.w === undefined ? 0.43 : layout.w,
    h: layout.h === undefined ? 0.12 : layout.h,
    fontSize: 10,
    rows: WRONG_EXCHANGE_GOODS,
    columns: pickerColumns(),
    rowKey: 'id',
    selectable: true,
    selectionType: 'radio',
    selectedKeys
  }]
}

function buildProductLibraryTables({ form, ui }) {
  const styleCode = String(form.libraryStyleCode || '').trim().toUpperCase()
  const rows = styleCode ? PRODUCT_LIBRARY_GOODS.filter(item => item.styleCode === styleCode) : PRODUCT_LIBRARY_GOODS
  return [{
    id: 'wrong-exchange-library-table',
    x: 0.19, y: 0.235, w: 0.62, h: 0.39,
    fontSize: 10,
    rows,
    columns: [
      { key: 'styleCode', title: '款式编码', width: 130 },
      { key: 'goodsCode', title: '商品编码', width: 180 },
      { key: 'goodsName', title: '商品名称', width: 220 },
      { key: 'spec', title: '颜色及规格', width: 140 },
      { key: 'unitPrice', title: '单价', width: 90, align: 'right' },
      { key: 'stock', title: '可用库存', width: 90, align: 'right' }
    ],
    rowKey: 'id',
    selectable: true,
    selectionType: 'radio',
    selectedKeys: ui['wrong-exchange-library-tableSelectedKeys'] || []
  }]
}

function buildWrongReturnProductLibraryTables({ form, ui }) {
  const styleCode = String(form.wrongReturnLibraryStyleCode || '').trim().toUpperCase()
  const sourceRows = PRODUCT_LIBRARY_GOODS.concat(WRONG_RETURN_LIBRARY_PRODUCT)
  const rows = ui.wrongReturnLibrarySearched && styleCode
    ? sourceRows.filter(item => item.styleCode.toUpperCase() === styleCode)
    : sourceRows
  return [{
    id: 'wrong-return-library-table',
    x: 0.19, y: 0.235, w: 0.62, h: 0.39,
    fontSize: 10,
    rows,
    columns: [
      { key: 'styleCode', title: '款式编码', width: 130 },
      { key: 'goodsCode', title: '商品编码', width: 180 },
      { key: 'goodsName', title: '商品名称', width: 220 },
      { key: 'spec', title: '颜色及规格', width: 140 },
      { key: 'unitPrice', title: '单价', width: 90, align: 'right' },
      { key: 'stock', title: '可用库存', width: 90, align: 'right' }
    ],
    rowKey: 'id',
    selectable: true,
    selectionType: 'radio',
    selectedKeys: ui['wrong-return-library-tableSelectedKeys'] || []
  }]
}

function buildNoInfoProductLibraryTables({ ui }) {
  const keyword = String(ui.noinfoSearchedGoodsCode || '').trim().toUpperCase()
  const rows = keyword
    ? PRODUCT_LIBRARY_GOODS.filter(item => item.styleCode === keyword || item.goodsCode === keyword)
    : PRODUCT_LIBRARY_GOODS
  return [{
    id: 'noinfo-product-library-table',
    x: 0.187, y: 0.235, w: 0.626, h: 0.555,
    fontSize: 10,
    rows,
    columns: [
      { key: 'styleCode', title: '款式编码', width: 130 },
      { key: 'goodsCode', title: '商品编码', width: 180 },
      { key: 'goodsName', title: '商品名称', width: 220 },
      { key: 'spec', title: '颜色及规格', width: 140 },
      { key: 'unitPrice', title: '单价', width: 90, align: 'right' },
      { key: 'stock', title: '可用库存', width: 90, align: 'right' }
    ],
    rowKey: 'id',
    selectable: true,
    selectionType: 'radio',
    selectedKeys: ui['noinfo-product-library-tableSelectedKeys'] || []
  }]
}

function buildNoInfoCreateGoodsTables(ui = {}) {
  const rows = ui.noinfoAddedGoods || []
  if (!rows.length) return []
  return [{
    id: 'noinfo-added-goods-table',
    x: 0.229, y: 0.446, w: 0.574, h: 0.25,
    fontSize: 10,
    rows,
    columns: [
      { key: 'goodsCode', title: '商品编码', width: 150 },
      { key: 'comboGoodsCode', title: '组合商品编码', width: 150 },
      { key: 'styleCode', title: '款式编码', width: 120 },
      { key: 'goodsName', title: '商品名称', width: 200 },
      { key: 'spec', title: '颜色及规格', width: 140 },
      { key: 'applyQty', title: '申请数量', width: 90, align: 'right' },
      { key: 'defectiveQty', title: '次品数量', width: 90, align: 'right' },
      { key: 'applyAmount', title: '申请金额', width: 90, align: 'right' }
    ],
    rowKey: 'id'
  }]
}

function selectWrongExchangeGood(ui, good) {
  const selectedKeys = (ui['third-wrong-exchange-goods-tableSelectedKeys'] || []).slice()
  const selectedRows = (ui['third-wrong-exchange-goods-tableSelectedRows'] || []).slice()
  if (selectedKeys.indexOf(good.id) < 0) selectedKeys.push(good.id)
  const rowIndex = selectedRows.findIndex(row => row.id === good.id)
  if (rowIndex < 0) selectedRows.push(good)
  else selectedRows.splice(rowIndex, 1, { ...selectedRows[rowIndex], ...good })
  return {
    'third-wrong-exchange-goods-tableSelectedKeys': selectedKeys,
    'third-wrong-exchange-goods-tableSelectedRows': selectedRows
  }
}

function appendWrongExchangeGood(ui, good) {
  const rows = ui.wrongExchangeExtraRows || []
  return {
    wrongExchangeExtraRows: rows.some(row => row.id === good.id) ? rows : rows.concat(good),
    ...selectWrongExchangeGood(ui, good)
  }
}

function buildWrongExchangeOrderTables(ui = {}) {
  const [orderTable] = buildPracticeOrderTables('换', ui)
  const orderSelected = (ui['third-practice-order-tableSelectedKeys'] || []).includes(PRACTICE_ORDER.id)
  const selectedKeys = ui['third-wrong-exchange-goods-tableSelectedKeys'] || []
  const selectedRows = ui['third-wrong-exchange-goods-tableSelectedRows'] || []
  const issueTypeOverrides = ui.wrongExchangeOrderIssueTypes || {}
  const rows = WRONG_EXCHANGE_GOODS.map(goods => {
    const changed = selectedRows.find(row => row.id === goods.id)
    return { ...goods, ...changed, issueType: issueTypeOverrides[goods.id] || (changed && changed.issueType) || goods.issueType }
  }).concat(ui.wrongExchangeExtraRows || [])
  const isSelected = row => selectedKeys.indexOf(row.id) > -1
  return [
    orderTable,
    ...(orderSelected ? [{
      id: 'third-wrong-exchange-goods-table',
      x: 0.045, y: 0.715, w: 0.94, h: 0.23,
      fontSize: 10,
      rows,
      columns: [
        { key: 'thumbnail', type: 'image', title: '缩略图', width: 68 },
        { key: 'goodsCode', title: '商品编码', width: 140 },
        { key: 'styleCode', title: '款式编码', width: 110 },
        { key: 'type', type: 'badge', title: '类型', width: 72 },
        { key: 'issueType', type: 'select', title: '明细问题类型', width: 150, options: ['应发未发', '错发已发'], inputDisabled: row => !isSelected(row) },
        { key: 'goodsName', title: '商品名称', width: 180 },
        { key: 'spec', title: '颜色及规格', width: 150 },
        { key: 'orderGoodsStatus', title: '订单商品状态', width: 120 },
        { key: 'goodsTag', title: '商品标签', width: 100 },
        { key: 'unitPrice', type: 'input', title: '单价', width: 88, align: 'right', inputDisabled: row => !isSelected(row) },
        { key: 'goodsAmount', title: '商品金额', width: 100, align: 'right' },
        { key: 'orderQty', title: '订单数量', width: 88, align: 'right' },
        { key: 'currentQty', type: 'input', title: '本次数量', width: 88, align: 'right', inputDisabled: row => !isSelected(row) },
        { key: 'defectiveQty', type: 'input', title: '次品数量', width: 88, align: 'right', inputDisabled: row => !isSelected(row) },
        { key: 'currentAmount', type: 'input', title: '本次金额', width: 100, align: 'right', inputDisabled: row => !isSelected(row) },
        { key: 'appliedReturnQty', title: '已申请退货', width: 100, align: 'right' },
        { key: 'actualReturnQty', title: '实退退货', width: 100, align: 'right' },
        { key: 'remark', type: 'input', title: '备注', width: 160, inputDisabled: row => !isSelected(row) },
        { key: 'availableStock', title: '可用库存', width: 88, align: 'right' }
      ],
      rowKey: 'id',
      selectable: true,
      selectedKeys
    }] : [])
  ]
}

function buildWrongReturnFields() {
  return [
    { id: 'wrong-return-express', model: 'wrongReturnExpress', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入', x: 0.112, y: 0.552, w: 0.05, h: 0.023 },
    { id: 'wrong-return-waybill', model: 'wrongReturnWaybill', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入', x: 0.231, y: 0.552, w: 0.057, h: 0.023 },
    { id: 'wrong-return-seller-subsidy', model: 'wrongReturnSellerSubsidy', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入', x: 0.602, y: 0.552, w: 0.06, h: 0.023 },
    { id: 'wrong-return-buyer-subsidy', model: 'wrongReturnBuyerSubsidy', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入', x: 0.725, y: 0.552, w: 0.057, h: 0.023 },
    { id: 'wrong-return-refund-freight', model: 'wrongReturnRefundFreight', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入', x: 0.848, y: 0.552, w: 0.06, h: 0.023 },
    { id: 'wrong-return-warehouse', model: 'wrongReturnWarehouse', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '选择退货仓', options: ['淘金仓库'], x: 0.23, y: 0.584, w: 0.065, h: 0.023 },
    { id: 'wrong-return-buyer-account', model: 'wrongReturnBuyerAccount', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入买家退款账号', x: 0.352, y: 0.584, w: 0.06, h: 0.023 },
    { id: 'wrong-return-seller-account', model: 'wrongReturnSellerAccount', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '选择卖家退款账号', options: ['淘金账户'], x: 0.477, y: 0.584, w: 0.06, h: 0.023 },
    { id: 'wrong-return-remark', model: 'wrongReturnRemark', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入备注', x: 0.602, y: 0.584, w: 0.18, h: 0.023 },
    { id: 'wrong-return-receiving-warehouse', model: 'wrongReturnReceivingWarehouse', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '选择收货仓', options: ['淘金仓库'], x: 0.848, y: 0.584, w: 0.06, h: 0.023 }
  ]
}

function buildNoInfoFields() {
  return [
    { id: 'noinfo-return-express', model: 'noinfoReturnExpress', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '买家退回快递', x: 0.3, y: 0.287, w: 0.08, h: 0.022 },
    { id: 'noinfo-return-waybill', model: 'noinfoReturnWaybill', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '退回快递单号', x: 0.45, y: 0.287, w: 0.09, h: 0.022 },
    { id: 'noinfo-remark', model: 'noinfoRemark', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '备注', x: 0.451, y: 0.352, w: 0.33, h: 0.022 },
    { id: 'noinfo-warehouse', model: 'noinfoWarehouse', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '选择退货仓', options: ['淘金仓库'], x: 0.3, y: 0.385, w: 0.082, h: 0.022 },
    { id: 'noinfo-shop', model: 'noinfoShop', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '选择店铺', options: ['淘金云官方旗舰店'], x: 0.45, y: 0.385, w: 0.094, h: 0.022 }
  ]
}

function buildWrongExchangeFields(form = {}) {
  const provinceOptions = receiverProvinces.map(item => item.name)
  const cityOptions = getReceiverCities(form.exchangeReceiverProvince)
  const districtOptions = getReceiverDistricts(form.exchangeReceiverProvince, form.exchangeReceiverCity)
  return [
    { id: 'exchange-return-express', model: 'exchangeReturnExpress', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入', x: 0.112, y: 0.552, w: 0.05, h: 0.023 },
    { id: 'exchange-return-waybill', model: 'exchangeReturnWaybill', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入', x: 0.231, y: 0.552, w: 0.057, h: 0.023 },
    { id: 'exchange-seller-subsidy', model: 'exchangeSellerSubsidy', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入', x: 0.602, y: 0.552, w: 0.06, h: 0.023 },
    { id: 'exchange-buyer-subsidy', model: 'exchangeBuyerSubsidy', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入', x: 0.725, y: 0.552, w: 0.057, h: 0.023 },
    { id: 'exchange-refund-freight', model: 'exchangeRefundFreight', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入', x: 0.848, y: 0.552, w: 0.06, h: 0.023 },
    { id: 'exchange-return-warehouse', model: 'exchangeReturnWarehouse', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '选择退货仓', options: ['淘金仓库'], x: 0.23, y: 0.584, w: 0.065, h: 0.023 },
    { id: 'exchange-buyer-account', model: 'exchangeBuyerAccount', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入买家退款账号', x: 0.352, y: 0.584, w: 0.06, h: 0.023 },
    { id: 'exchange-seller-account', model: 'exchangeSellerAccount', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '选择卖家退款账号', options: ['淘金账户'], x: 0.477, y: 0.584, w: 0.06, h: 0.023 },
    { id: 'exchange-remark', model: 'exchangeRemark', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入备注', x: 0.602, y: 0.584, w: 0.18, h: 0.023 },
    { id: 'exchange-receiving-warehouse', model: 'exchangeReceivingWarehouse', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '选择收货仓', options: ['淘金仓库'], x: 0.848, y: 0.584, w: 0.06, h: 0.023 },
    { id: 'exchange-shipping-warehouse', model: 'exchangeShippingWarehouse', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '选择发货仓', options: ['淘金仓库'], x: 0.478, y: 0.615, w: 0.058, h: 0.023 },
    { id: 'exchange-receiver-province', model: 'exchangeReceiverProvince', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '省份', options: provinceOptions, x: 0.107, y: 0.65, w: 0.037, h: 0.023,
      onInput: ({ setForm }) => setForm({ exchangeReceiverCity: '', exchangeReceiverDistrict: '' }) },
    { id: 'exchange-receiver-city', model: 'exchangeReceiverCity', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '城市', options: cityOptions, x: 0.16, y: 0.65, w: 0.047, h: 0.023,
      onInput: ({ setForm }) => setForm({ exchangeReceiverDistrict: '' }) },
    { id: 'exchange-receiver-district', model: 'exchangeReceiverDistrict', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '县市', options: districtOptions, x: 0.213, y: 0.65, w: 0.047, h: 0.023 },
    { id: 'exchange-receiver-address', model: 'exchangeReceiverAddress', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '详细地址', x: 0.267, y: 0.65, w: 0.142, h: 0.023 },
    { id: 'exchange-receiver-name', model: 'exchangeReceiverName', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '收货人', x: 0.477, y: 0.65, w: 0.06, h: 0.023 },
    { id: 'exchange-receiver-phone', model: 'exchangeReceiverPhone', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '联系手机', x: 0.602, y: 0.65, w: 0.06, h: 0.023 },
    { id: 'exchange-out-express', model: 'exchangeOutExpress', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '选择寄出快递', options: DOMESTIC_EXPRESS_COMPANIES, x: 0.848, y: 0.65, w: 0.06, h: 0.023 }
  ]
}

function buildResendOrderFields(form = {}, options = {}) {
  const provinceOptions = receiverProvinces.map(item => item.name)
  const cityOptions = getReceiverCities(form.receiverProvince)
  const districtOptions = getReceiverDistricts(form.receiverProvince, form.receiverCity)
  const zeroPlaceholder = options.showZeroPlaceholder === true ? '0' : '请输入'
  return [
    { id: 'return-express', model: 'returnExpress', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入', x: 0.112, y: 0.552, w: 0.05, h: 0.023 },
    { id: 'return-waybill', model: 'returnWaybill', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入', x: 0.231, y: 0.552, w: 0.057, h: 0.023 },
    { id: 'seller-subsidy', model: 'sellerSubsidy', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: zeroPlaceholder, x: 0.602, y: 0.552, w: 0.06, h: 0.023 },
    { id: 'buyer-subsidy', model: 'buyerSubsidy', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入', x: 0.725, y: 0.552, w: 0.057, h: 0.023 },
    { id: 'refund-freight', model: 'refundFreight', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: zeroPlaceholder, x: 0.848, y: 0.552, w: 0.06, h: 0.023 },
    { id: 'remark', model: 'remark', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入备注', x: 0.478, y: 0.584, w: 0.18, h: 0.022 },
    { id: 'shipping-warehouse', model: 'shippingWarehouse', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '选择发货仓', options: ['淘金仓库'], x: 0.23, y: 0.615, w: 0.058, h: 0.023 },
    { id: 'receiver-province', model: 'receiverProvince', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '省份', options: provinceOptions, x: 0.107, y: 0.65, w: 0.037, h: 0.023,
      onInput: ({ setForm }) => setForm({ receiverCity: '', receiverDistrict: '' }) },
    { id: 'receiver-city', model: 'receiverCity', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '城市', options: cityOptions, x: 0.16, y: 0.65, w: 0.047, h: 0.023,
      onInput: ({ setForm }) => setForm({ receiverDistrict: '' }) },
    { id: 'receiver-district', model: 'receiverDistrict', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '县市', options: districtOptions, x: 0.213, y: 0.65, w: 0.047, h: 0.023 },
    { id: 'receiver-address', model: 'receiverAddress', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '详细地址', x: 0.267, y: 0.65, w: 0.142, h: 0.023 },
    { id: 'receiver-name', model: 'receiverName', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '收货人', x: 0.477, y: 0.65, w: 0.06, h: 0.023 },
    { id: 'receiver-phone', model: 'receiverPhone', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '联系手机', x: 0.602, y: 0.65, w: 0.06, h: 0.023 },
    { id: 'out-express', model: 'outExpress', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '选择寄出快递', options: DOMESTIC_EXPRESS_COMPANIES, x: 0.848, y: 0.65, w: 0.06, h: 0.023 }
  ]
}

function validateResendOrderForm(form, options = {}) {
  const expected = {
    returnExpress: '申通快递',
    returnWaybill: 'st12654458855',
    sellerSubsidy: '0',
    buyerSubsidy: '0',
    refundFreight: '8',
    shippingWarehouse: '淘金仓库',
    receiverProvince: '陕西省',
    receiverCity: '西安市',
    receiverDistrict: '雁塔区',
    receiverAddress: '丈八街道丹轩梓园3号楼',
    receiverName: '朱小明',
    receiverPhone: '13800138000',
    outExpress: '京东快递'
  }
  if (options.refundFreight !== undefined) expected.refundFreight = options.refundFreight
  if (options.skipReturnInfo === true) {
    delete expected.returnExpress
    delete expected.returnWaybill
  }
  const missing = Object.keys(expected).find(key => String(form[key] || '').trim() !== expected[key])
  if (!missing) return { ok: true }
  const messages = {
    returnExpress: '请填写买家退回快递：申通快递',
    returnWaybill: '请填写买家退回快递单号：st12654458855',
    sellerSubsidy: '请填写卖家应补：0',
    buyerSubsidy: '请填写买家应补：0',
    refundFreight: '请填写应退运费：' + expected.refundFreight,
    shippingWarehouse: '请选择发货仓：淘金仓库',
    receiverProvince: '请选择收货省份：陕西省',
    receiverCity: '请选择收货城市：西安市',
    receiverDistrict: '请选择收货县市：雁塔区',
    receiverAddress: '请填写详细地址：丈八街道丹轩梓园3号楼',
    receiverName: '请填写收货人：朱小明',
    receiverPhone: '请填写联系手机：13800138000',
    outExpress: '请选择寄出快递：京东快递'
  }
  return { ok: false, msg: messages[missing] }
}

function validateResendOrder({ form, ui }) {
  const formResult = validateResendOrderForm(form)
  if (!formResult.ok) return formResult
  const selectedKeys = ui['third-practice-goods-tableSelectedKeys'] || []
  return selectedKeys.indexOf('practice-goods-1') > -1
    ? { ok: true }
    : { ok: false, msg: '请勾选商品编码为 ' + TARGET_PRACTICE_GOODS_CODE + ' 的商品。' }
}

function validateLeakResendOrder({ form, ui }) {
  const formResult = validateResendOrderForm(form, { skipReturnInfo: true, refundFreight: '0' })
  if (!formResult.ok) return formResult
  const selectedKeys = ui['third-leak-resend-goods-tableSelectedKeys'] || []
  if (selectedKeys.indexOf('practice-goods-1') < 0) return { ok: false, msg: '请勾选商品编码为 ' + TARGET_PRACTICE_GOODS_CODE + ' 的第一个商品。' }
  const selected = {
    ...((ui['third-leak-resend-goods-tableSelectedRows'] || []).find(row => row.id === 'practice-goods-1') || {}),
    ...((ui['third-leak-resend-goods-tableRowDrafts'] || {})['practice-goods-1'] || {})
  }
  if (selected.issueType !== '应发未发') return { ok: false, msg: '请选择明细问题类型：应发未发。' }
  return String(selected.currentQty || '').trim() === '1'
    ? { ok: true }
    : { ok: false, msg: '请将第一个商品的本次数量填写为 1。' }
}

function validateWrongReturnCreation({ form, ui }) {
  const addedGoods = ui.wrongReturnAddedGoods || []
  if (!addedGoods.some(row => row.styleCode === WRONG_RETURN_LIBRARY_PRODUCT.styleCode)) {
    return { ok: false, msg: '请先添加错发已发商品 ' + WRONG_RETURN_LIBRARY_PRODUCT.styleCode + '。' }
  }
  const selectedKeys = ui['third-wrong-return-goods-tableSelectedKeys'] || []
  if (!selectedKeys.includes(WRONG_RETURN_ADDED_GOOD.id)) return { ok: false, msg: '请勾选错发已发商品 ' + WRONG_RETURN_LIBRARY_PRODUCT.styleCode + '。' }
  const expected = {
    wrongReturnExpress: '申通快递',
    wrongReturnWaybill: 'st12654458855',
    wrongReturnSellerSubsidy: '0',
    wrongReturnBuyerSubsidy: '0',
    wrongReturnRefundFreight: '8',
    wrongReturnWarehouse: '淘金仓库',
    wrongReturnBuyerAccount: '13800138000',
    wrongReturnSellerAccount: '淘金账户',
    wrongReturnRemark: '错发退货退款'
  }
  const invalidKey = Object.keys(expected).find(key => String(form[key] || '').trim() !== expected[key])
  const messages = {
    wrongReturnExpress: '请填写买家退回快递：申通快递',
    wrongReturnWaybill: '请填写买家退回快递单号：st12654458855',
    wrongReturnSellerSubsidy: '请填写卖家应补：0',
    wrongReturnBuyerSubsidy: '请填写买家应补：0',
    wrongReturnRefundFreight: '请填写应退运费：8',
    wrongReturnWarehouse: '请选择退货仓：淘金仓库',
    wrongReturnBuyerAccount: '请填写买家退款账号：13800138000',
    wrongReturnSellerAccount: '请选择卖家退款账号：淘金账户',
    wrongReturnRemark: '请填写备注：错发退货退款'
  }
  if (invalidKey) return { ok: false, msg: messages[invalidKey] }
  return { ok: true }
}

function validateNoInfoCreation({ form, ui }) {
  if (!(ui.noinfoAddedGoods || []).length) return { ok: false, msg: '请先添加退回来的商品。' }
  const expected = {
    noinfoReturnExpress: '申通快递',
    noinfoReturnWaybill: 'st12654458855',
    noinfoRemark: '无信息件退货',
    noinfoWarehouse: '淘金仓库',
    noinfoShop: '淘金云官方旗舰店'
  }
  const invalidKey = Object.keys(expected).find(key => String(form[key] || '').trim() !== expected[key])
  if (!invalidKey) return { ok: true }
  const messages = {
    noinfoReturnExpress: '请填写买家退回快递：申通快递',
    noinfoReturnWaybill: '请填写买家退回快递单号：st12654458855',
    noinfoRemark: '请填写备注：无信息件退货',
    noinfoWarehouse: '请选择退货仓：淘金仓库',
    noinfoShop: '请选择店铺：淘金云官方旗舰店'
  }
  return { ok: false, msg: messages[invalidKey] }
}

function validateWrongExchangeCreation({ form, ui }) {
  const incompleteActions = []
  if (!ui.wrongExchangeAddedMissing) incompleteActions.push('添加应发未发商品')
  if (!ui.wrongExchangeAddedWrong) incompleteActions.push('添加错发已发商品')
  if (!ui.wrongExchangeAddedExchange) incompleteActions.push('添加换货商品（订单）')
  if (!ui.wrongExchangeIssueRegistrationCompleted) incompleteActions.push('售后问题登记')
  if (incompleteActions.length) return { ok: false, msg: '请先完成：' + incompleteActions.join('、') + '。' }

  const expected = {
    exchangeReturnExpress: '申通快递',
    exchangeReturnWaybill: 'st12654458855',
    exchangeSellerSubsidy: '0',
    exchangeBuyerSubsidy: '0',
    exchangeRefundFreight: '8',
    exchangeReturnWarehouse: '淘金仓库',
    exchangeBuyerAccount: '13800138000',
    exchangeSellerAccount: '淘金账户',
    exchangeReceivingWarehouse: '淘金仓库',
    exchangeShippingWarehouse: '淘金仓库',
    exchangeReceiverProvince: '陕西省',
    exchangeReceiverCity: '西安市',
    exchangeReceiverDistrict: '雁塔区',
    exchangeReceiverAddress: '丈八街道丹轩梓园3号楼',
    exchangeReceiverName: '朱小明',
    exchangeReceiverPhone: '13800138000',
    exchangeOutExpress: '京东快递'
  }
  const invalidKey = Object.keys(expected).find(key => String(form[key] || '').trim() !== expected[key])
  const messages = {
    exchangeReturnExpress: '请填写买家退回快递：申通快递',
    exchangeReturnWaybill: '请填写买家退回快递单号：st12654458855',
    exchangeSellerSubsidy: '请填写卖家应补：0',
    exchangeBuyerSubsidy: '请填写买家应补：0',
    exchangeRefundFreight: '请填写应退运费：8',
    exchangeReturnWarehouse: '请选择退货仓：淘金仓库',
    exchangeBuyerAccount: '请填写买家退款账号：13800138000',
    exchangeSellerAccount: '请选择卖家退款账号：淘金账户',
    exchangeReceivingWarehouse: '请选择收货仓：淘金仓库',
    exchangeShippingWarehouse: '请选择发货仓：淘金仓库',
    exchangeReceiverProvince: '请选择收货省份：陕西省',
    exchangeReceiverCity: '请选择收货城市：西安市',
    exchangeReceiverDistrict: '请选择收货县市：雁塔区',
    exchangeReceiverAddress: '请填写详细地址：丈八街道丹轩梓园3号楼',
    exchangeReceiverName: '请填写收货人：朱小明',
    exchangeReceiverPhone: '请填写联系手机：13800138000',
    exchangeOutExpress: '请选择寄出快递：京东快递'
  }
  if (invalidKey) return { ok: false, msg: messages[invalidKey] }
  const selectedKeys = ui['third-wrong-exchange-goods-tableSelectedKeys'] || []
  if (!selectedKeys.includes('wrong-exchange-goods-1')) return { ok: false, msg: '请选中应发未发商品 ' + TARGET_PRACTICE_GOODS_CODE }
  if (!selectedKeys.includes('added-wrong-sent-goods-1')) return { ok: false, msg: '请选中错发已发商品 ' + TARGET_LIBRARY_GOODS_CODE }
  return selectedKeys.includes('added-exchange-goods-1')
    ? { ok: true }
    : { ok: false, msg: '请选中要换商品 ' + TARGET_PRACTICE_GOODS_CODE }
}

const SIMULATED_AFTERSALE = {
  id: 'simulated-aftersale-1',
  aftersaleNo: '1090155421',
  businessType: '普通',
  internalOrderNo: '381421',
  applyTime: '2026-07-13 23:00:00',
  onlineType: '普通补发',
  aftersaleCategory: '补发',
  status: '待确认',
  onlineStatus: '等待补发',
  cargoStatus: '买家未收到货',
  buyerAccount: '顾**',
  externalTradeNo: '',
  receivingWarehouse: '',
  warehouse: '淘金云仓库',
  returnLogistics: '',
  returnInternationalNo: ''
}

const SIMULATED_WRONG_RETURN_AFTERSALE = {
  id: 'simulated-aftersale-2',
  aftersaleNo: '1090155422',
  businessType: '错发',
  internalOrderNo: '381421',
  applyTime: '2026-07-21 15:30:00',
  onlineType: '错发退货',
  aftersaleCategory: '普通退货',
  status: '待确认',
  onlineStatus: '等待退货',
  cargoStatus: '买家已寄回',
  buyerAccount: PRACTICE_ORDER.buyerAccount,
  externalTradeNo: '',
  receivingWarehouse: '',
  warehouse: '淘金仓库',
  returnLogistics: '申通快递',
  returnInternationalNo: 'st12654458855'
}

const SIMULATED_WRONG_EXCHANGE_AFTERSALE = {
  id: 'simulated-aftersale-3',
  aftersaleNo: '1090155423',
  businessType: '错发',
  internalOrderNo: '381421',
  applyTime: '2026-07-21 16:00:00',
  onlineType: '错发换货',
  aftersaleCategory: '换货',
  status: '待确认',
  onlineStatus: '等待换货',
  cargoStatus: '买家已寄回',
  buyerAccount: PRACTICE_ORDER.buyerAccount,
  externalTradeNo: '',
  receivingWarehouse: '',
  warehouse: '淘金仓库',
  returnLogistics: '申通快递',
  returnInternationalNo: 'st12654458855'
}

const SIMULATED_LEAK_RESEND_AFTERSALE = {
  id: 'simulated-aftersale-4',
  aftersaleNo: '1090155424',
  businessType: '漏发',
  internalOrderNo: '381421',
  applyTime: '2026-07-22 10:30:00',
  onlineType: '漏发补发',
  aftersaleCategory: '补发',
  status: '待确认',
  onlineStatus: '等待补发',
  cargoStatus: '买家未收到货',
  buyerAccount: PRACTICE_ORDER.buyerAccount,
  externalTradeNo: '',
  receivingWarehouse: '',
  warehouse: '淘金仓库',
  returnLogistics: '申通快递',
  returnInternationalNo: 'st12654458855'
}

const SIMULATED_NOINFO_AFTERSALE = {
  id: 'simulated-aftersale-5',
  aftersaleNo: '1090155425',
  businessType: '无信息件',
  internalOrderNo: '',
  applyTime: '2026-07-22 14:00:00',
  onlineType: '无信息件',
  aftersaleCategory: '普通退货',
  status: '待确认',
  onlineStatus: '待处理',
  cargoStatus: '买家已寄回',
  buyerAccount: '',
  externalTradeNo: '',
  receivingWarehouse: '淘金仓库',
  warehouse: '淘金仓库',
  returnLogistics: '',
  returnInternationalNo: ''
}

const SIMULATED_AFTERSALE_GOODS = [{
  id: 'simulated-aftersale-goods-1',
  thumbnail: '',
  goodsCode: PRACTICE_GOODS[0].goodsCode,
  comboGoodsCode: '',
  styleCode: PRACTICE_GOODS[0].styleCode,
  goodsName: PRACTICE_GOODS[0].goodsName,
  spec: PRACTICE_GOODS[0].spec,
  goodsTag: '每日加权',
  onlineDetailAmount: PRACTICE_GOODS[0].goodsAmount,
  unitPrice: PRACTICE_GOODS[0].unitPrice,
  applyQty: 1,
  actualReturnQty: 0
}]

const SIMULATED_WRONG_RETURN_AFTERSALE_GOODS = [{
  id: 'simulated-wrong-return-goods-1',
  thumbnail: '',
  goodsCode: TARGET_PRACTICE_GOODS_CODE,
  comboGoodsCode: '',
  styleCode: TARGET_PRACTICE_STYLE_CODE,
  goodsName: PRACTICE_GOODS[0].goodsName,
  spec: PRACTICE_GOODS[0].spec,
  goodsTag: '每日加权',
  onlineDetailAmount: PRACTICE_GOODS[0].goodsAmount,
  unitPrice: PRACTICE_GOODS[0].unitPrice,
  applyQty: 1,
  actualReturnQty: 0
}, {
  id: 'simulated-wrong-return-goods-2',
  thumbnail: '',
  goodsCode: WRONG_RETURN_LIBRARY_PRODUCT.goodsCode,
  comboGoodsCode: '',
  styleCode: WRONG_RETURN_LIBRARY_PRODUCT.styleCode,
  goodsName: WRONG_RETURN_LIBRARY_PRODUCT.goodsName,
  spec: WRONG_RETURN_LIBRARY_PRODUCT.spec,
  goodsTag: '',
  onlineDetailAmount: WRONG_RETURN_LIBRARY_PRODUCT.unitPrice,
  unitPrice: WRONG_RETURN_LIBRARY_PRODUCT.unitPrice,
  applyQty: 1,
  actualReturnQty: 0
}]

const SIMULATED_WRONG_EXCHANGE_AFTERSALE_GOODS = [{
  id: 'simulated-wrong-exchange-goods-1',
  thumbnail: '',
  goodsCode: TARGET_PRACTICE_GOODS_CODE,
  comboGoodsCode: '',
  styleCode: TARGET_PRACTICE_STYLE_CODE,
  goodsName: PRACTICE_GOODS[0].goodsName,
  spec: PRACTICE_GOODS[0].spec,
  goodsTag: '每日加权',
  onlineDetailAmount: PRACTICE_GOODS[0].goodsAmount,
  unitPrice: PRACTICE_GOODS[0].unitPrice,
  applyQty: 1,
  actualReturnQty: 0
}, {
  id: 'simulated-wrong-exchange-goods-2',
  thumbnail: '',
  goodsCode: TARGET_LIBRARY_GOODS_CODE,
  comboGoodsCode: '',
  styleCode: TARGET_LIBRARY_STYLE_CODE,
  goodsName: TARGET_LIBRARY_GOODS.goodsName,
  spec: TARGET_LIBRARY_GOODS.spec,
  goodsTag: '',
  onlineDetailAmount: TARGET_LIBRARY_GOODS.unitPrice,
  unitPrice: TARGET_LIBRARY_GOODS.unitPrice,
  applyQty: 1,
  actualReturnQty: 0
}]

const SIMULATED_LEAK_RESEND_AFTERSALE_GOODS = [{
  id: 'simulated-leak-resend-goods-1',
  thumbnail: '',
  goodsCode: TARGET_PRACTICE_GOODS_CODE,
  comboGoodsCode: '',
  styleCode: TARGET_PRACTICE_STYLE_CODE,
  goodsName: PRACTICE_GOODS[0].goodsName,
  spec: PRACTICE_GOODS[0].spec,
  goodsTag: '每日加权',
  onlineDetailAmount: PRACTICE_GOODS[0].goodsAmount,
  unitPrice: PRACTICE_GOODS[0].unitPrice,
  applyQty: 1,
  actualReturnQty: 0
}]

const SIMULATED_NOINFO_AFTERSALE_GOODS = [{
  id: 'simulated-noinfo-goods-1',
  thumbnail: '',
  goodsCode: TARGET_LIBRARY_GOODS_CODE,
  comboGoodsCode: '',
  styleCode: TARGET_LIBRARY_STYLE_CODE,
  goodsName: TARGET_LIBRARY_GOODS.goodsName,
  spec: TARGET_LIBRARY_GOODS.spec,
  goodsTag: '',
  onlineDetailAmount: TARGET_LIBRARY_GOODS.unitPrice,
  unitPrice: TARGET_LIBRARY_GOODS.unitPrice,
  applyAmount: TARGET_LIBRARY_GOODS.unitPrice,
  applyQty: 1,
  actualReturnQty: 0
}]

const AFTERSALE_GOODS_BY_ID = {
  [SIMULATED_AFTERSALE.id]: SIMULATED_AFTERSALE_GOODS,
  [SIMULATED_WRONG_RETURN_AFTERSALE.id]: SIMULATED_WRONG_RETURN_AFTERSALE_GOODS,
  [SIMULATED_WRONG_EXCHANGE_AFTERSALE.id]: SIMULATED_WRONG_EXCHANGE_AFTERSALE_GOODS,
  [SIMULATED_LEAK_RESEND_AFTERSALE.id]: SIMULATED_LEAK_RESEND_AFTERSALE_GOODS,
  [SIMULATED_NOINFO_AFTERSALE.id]: SIMULATED_NOINFO_AFTERSALE_GOODS
}

function buildAftersaleListTables({ ui }, onSelect) {
  const rows = ui.createdThirdAftersales || []
  const selectedKeys = ui['third-aftersale-tableSelectedKeys'] || []
  const selectedId = selectedKeys[0]
  const goodsRows = AFTERSALE_GOODS_BY_ID[selectedId] || []

  return [
    {
      id: 'third-aftersale-table',
      x: 0.165, y: 0.21, w: 0.84, h: 0.51,
      rows,
      columns: [
        { key: 'aftersaleNo', title: '售后单号', width: 126 },
        { key: 'businessType', title: '业务类型', width: 92 },
        { key: 'internalOrderNo', title: '内部订单号', width: 120 },
        { key: 'applyTime', title: '申请日期', width: 160 },
        { key: 'onlineType', title: '线上类型', width: 92 },
        { key: 'aftersaleCategory', title: '售后分类', width: 92 },
        { key: 'status', title: '状态', width: 78 },
        { key: 'onlineStatus', title: '线上状态', width: 100 },
        { key: 'cargoStatus', title: '货物状态', width: 120 },
        { key: 'buyerAccount', title: '买家账号', width: 96 },
        { key: 'externalTradeNo', title: '外部交易单号', width: 130 },
        { key: 'receivingWarehouse', title: '收货仓', width: 96 },
        { key: 'warehouse', title: '仓库', width: 110 },
        { key: 'returnLogistics', title: '退回物流商渠道', width: 130 },
        { key: 'returnInternationalNo', title: '退回国际单号', width: 130 }
      ],
      rowKey: 'id',
      selectable: true,
      selectionType: 'radio',
      selectedKeys,
      onSelectionChange: onSelect
    },
    {
      id: 'third-aftersale-goods-table',
      x: 0.165, y: 0.76, w: 0.84, h: 0.21,
      rows: goodsRows,
      columns: [
        { key: 'thumbnail', type: 'image', title: '缩略图', width: 68 },
        { key: 'goodsCode', title: '商品编码', width: 150 },
        { key: 'comboGoodsCode', title: '组合商品编码', width: 150 },
        { key: 'styleCode', title: '款式编码', width: 118 },
        { key: 'goodsName', title: '商品名称', width: 270 },
        { key: 'spec', title: '颜色及规格', width: 220 },
        { key: 'goodsTag', title: '商品标签', width: 110 },
        { key: 'onlineDetailAmount', title: '线上明细金额', width: 120, align: 'right' },
        { key: 'unitPrice', title: '单价', width: 88, align: 'right' },
        { key: 'applyQty', title: '申请数量', width: 88, align: 'right' },
        { key: 'actualReturnQty', title: '实退数量', width: 88, align: 'right' }
      ],
      rowKey: 'id'
    }
  ]
}

function buildOrderAftersaleDetailTables() {
  return [{
    id: 'third-order-aftersale-detail-table',
    x: 0.045, y: 0.518, w: 0.94, h: 0.40,
    fontSize: 10,
    rows: [{
      id: 'order-aftersale-detail-1',
      aftersaleNo: '1090154418',
      aftersaleCategory: '仅退款',
      status: '已确认',
      goodsName: PRACTICE_GOODS[0].goodsName,
      goodsCode: TARGET_PRACTICE_GOODS_CODE,
      styleCode: TARGET_PRACTICE_STYLE_CODE,
      spec: PRACTICE_GOODS[0].spec,
      applyQty: 1,
      actualReturnQty: 0,
      refundAmount: PRACTICE_GOODS[0].unitPrice,
      detailCategory: '退款',
      creator: '客服-小淘'
    }],
    columns: [
      { key: 'aftersaleNo', title: '售后单号', width: 130 },
      { key: 'aftersaleCategory', title: '售后分类', width: 100 },
      { key: 'status', title: '状态', width: 90 },
      { key: 'goodsName', title: '商品名称', width: 220 },
      { key: 'goodsCode', title: '商品编码', width: 150 },
      { key: 'styleCode', title: '款式编码', width: 130 },
      { key: 'spec', title: '颜色及规格', width: 190 },
      { key: 'applyQty', title: '申请数量', width: 88, align: 'right' },
      { key: 'actualReturnQty', title: '实收数量', width: 88, align: 'right' },
      { key: 'refundAmount', title: '实退实收金额', width: 120, align: 'right' },
      { key: 'detailCategory', title: '明细类别', width: 100 },
      { key: 'creator', title: '创建人', width: 130 }
    ],
    rowKey: 'id'
  }]
}

export function getJstErpCreateAftersaleScenario() {
  const scenario = {
    initialStepId: 'aftersale-list',
    initialUi: {},
    initialForm: {
      orderCode: '', goodsCode: '', returnExpress: '', returnWaybill: '', sellerSubsidy: '', buyerSubsidy: '', refundFreight: '', remark: '',
      shippingWarehouse: '', receiverProvince: '', receiverCity: '', receiverDistrict: '', receiverAddress: '', receiverName: '', receiverPhone: '', outExpress: '',
      wrongReturnExpress: '', wrongReturnWaybill: '', wrongReturnSellerSubsidy: '', wrongReturnBuyerSubsidy: '', wrongReturnRefundFreight: '', wrongReturnWarehouse: '', wrongReturnSellerAccount: '', wrongReturnBuyerAccount: '', wrongReturnRemark: '', wrongReturnReceivingWarehouse: '', wrongReturnLibraryStyleCode: '',
      exchangeReturnExpress: '', exchangeReturnWaybill: '', exchangeSellerSubsidy: '', exchangeBuyerSubsidy: '', exchangeRefundFreight: '', exchangeReturnWarehouse: '', exchangeSellerAccount: '', exchangeBuyerAccount: '', exchangeRemark: '', exchangeReceivingWarehouse: '', exchangeShippingWarehouse: '', exchangeReceiverProvince: '', exchangeReceiverCity: '', exchangeReceiverDistrict: '', exchangeReceiverAddress: '', exchangeReceiverName: '', exchangeReceiverPhone: '', exchangeOutExpress: '', libraryStyleCode: '',
      noinfoReturnExpress: '', noinfoReturnWaybill: '', noinfoRemark: '', noinfoWarehouse: '', noinfoShop: ''
    },
    steps: [
      {
        id: 'aftersale-list',
        image: SCENE_IMAGES.aftersaleList,
        aspectRatio: 2,
        tip: ({ ui }) => (ui.createdThirdAftersales || []).length
          ? '售后单已创建，请选中售后单查看下方的商品明细。'
          : '当前没有售后单，售后单列表及商品明细均为空。点击<span style="color:red;font-weight:bold;">创建退货补发换货售后单</span>开始练习。',
        tables: context => buildAftersaleListTables(context, ({ checked, go }) => {
          if (checked) go('done')
        }),
        hotspots: ({ ui }) => (ui.createdThirdAftersales || []).length ? [] : [{
          id: 'create-aftersale', x: 0.17, y: 0.145, w: 0.10, h: 0.035, highlight: 'primary', next: 'order-search'
        }]
      },
      {
        id: 'noinfo-order-result',
        image: SCENE_IMAGES.empty,
        aspectRatio: 2,
        tip: '无需搜索订单，请直接点击页面中的红色按钮<span style="color:red;font-weight:bold;">创建无信息件售后单</span>。',
        hotspots: [{
          id: 'create-noinfo-aftersale', x: 0.707, y: 0.091, w: 0.07, h: 0.03, highlight: 'primary', next: 'create-noinfo'
        }]
      },
      {
        id: 'leak-order-search',
        image: SCENE_IMAGES.empty,
        aspectRatio: 2,
        tip: '输入线上订单号 <span style="color:red;font-weight:bold;">' + TARGET_ORDER_CODE + '</span> 并点击搜索，创建<span style="color:red;font-weight:bold;">漏发售后业务－补发</span>。',
        fields: [ORDER_FIELD],
        hotspots: [{
          id: 'search-leak-order', x: 0.657, y: 0.091, w: 0.03, h: 0.028, highlight: 'primary',
          guard: ({ form }) => String(form.orderCode || '').trim() === TARGET_ORDER_CODE
            ? { ok: true }
            : { ok: false, msg: '请输入正确的线上订单号 ' + TARGET_ORDER_CODE },
          set: CLEAR_PRACTICE_ORDER_SELECTION,
          next: 'select-leak-business'
        }]
      },
      {
        id: 'select-leak-business',
        image: SCENE_IMAGES.return,
        aspectRatio: 2,
        tip: '订单搜索完成，当前处于<span style="color:red;font-weight:bold;">普通售后业务</span>。请点击<span style="color:red;font-weight:bold;">漏发售后业务</span>。',
        fields: [ORDER_FIELD],
        tables: ({ ui }) => buildPracticeOrderTables('退', ui),
        hotspots: [{
          id: 'enter-leak-business', x: 0.15, y: 0.492, w: 0.053, h: 0.027, highlight: 'primary',
          guard: requirePracticeOrderSelection,
          next: 'create-leak-resend'
        }]
      },
      {
        id: 'create-leak-resend',
        image: r('3-leak-resend.png'),
        aspectRatio: 2,
        tip: '已选择<span style="color:red;font-weight:bold;">漏发售后业务－补发</span>。请勾选第一个商品编码为<span style="color:red;font-weight:bold;">' + TARGET_PRACTICE_GOODS_CODE + '</span>的商品，选择明细问题类型<span style="color:red;font-weight:bold;">应发未发</span>，并将本次数量填写为<span style="color:red;font-weight:bold;">1</span>。卖家应补<span style="color:red;font-weight:bold;">0</span>、买家应补<span style="color:red;font-weight:bold;">0</span>、应退运费<span style="color:red;font-weight:bold;">0</span>元；发货仓选择<span style="color:red;font-weight:bold;">淘金仓库</span>；备注<span style="color:red;font-weight:bold;">漏发补发</span>；收货地址为陕西省西安市雁塔区丈八街道丹轩梓园3号楼，收货人朱小明、13800138000，寄出快递选择京东快递，再点击<span style="color:red;font-weight:bold;">确定创建新售后单</span>。',
        fields: ({ form }) => [ORDER_FIELD, ...buildResendOrderFields(form)],
        tables: ({ ui }) => buildLeakResendOrderTables(ui),
        hotspots: [{
          id: 'create-leak-resend-aftersale', x: 0.91, y: 0.945, w: 0.065, h: 0.025, highlight: 'primary',
          guard: validateLeakResendOrder,
          action: ({ ui }) => ({ set: { createdThirdAftersales: [...(ui.createdThirdAftersales || []), SIMULATED_LEAK_RESEND_AFTERSALE] }, next: 'after-leak-resend-list' })
        }]
      },
      {
        id: 'after-leak-resend-list',
        image: SCENE_IMAGES.aftersaleList,
        aspectRatio: 2,
        tip: '漏发售后业务－补发已创建。请继续创建<span style="color:red;font-weight:bold;">无信息件售后单</span>。',
        tables: context => buildAftersaleListTables(context),
        hotspots: [{
          id: 'create-noinfo-aftersale-from-list', x: 0.17, y: 0.145, w: 0.10, h: 0.035, highlight: 'primary', next: 'noinfo-order-result'
        }]
      },
      {
        id: 'order-search',
        image: SCENE_IMAGES.empty,
        aspectRatio: 2,
        tip: '输入线上订单号 <span style="color:red;font-weight:bold;">' + TARGET_ORDER_CODE + '</span> 并点击搜索。',
        fields: [ORDER_FIELD],
        hotspots: [{
          id: 'search-order', x: 0.657, y: 0.091, w: 0.03, h: 0.028, highlight: 'primary',
          guard: ({ form }) => String(form.orderCode || '').trim() === TARGET_ORDER_CODE
            ? { ok: true }
            : { ok: false, msg: '请输入正确的线上订单号 ' + TARGET_ORDER_CODE },
          set: CLEAR_PRACTICE_ORDER_SELECTION,
          next: 'select-resend'
        }]
      },
      {
        id: 'select-resend',
        image: SCENE_IMAGES.return,
        aspectRatio: 2,
        tip: '订单查询成功，当前为<span style="color:red;font-weight:bold;">普通售后业务</span>，请点击售后分类中的<span style="color:red;font-weight:bold;">补发</span>。',
        fields: [ORDER_FIELD],
        tables: ({ ui }) => buildPracticeOrderTables('退', ui),
        hotspots: [{
          id: 'resend-type', x: 0.233, y: 0.526, w: 0.04, h: 0.027, highlight: 'primary',
          guard: requirePracticeOrderSelection,
          next: 'create-resend'
        }]
      },
      {
        id: 'create-resend',
        image: SCENE_IMAGES.resend,
        aspectRatio: 2,
        tip: '已选择<span style="color:red;font-weight:bold;">普通售后业务-补发</span>。<br>请勾选商品编码为<span style="color:red;font-weight:bold;">' + TARGET_PRACTICE_GOODS_CODE + '</span>的商品；本次数量填写<span style="color:red;font-weight:bold;">1</span>。买家退回快递<span style="color:red;font-weight:bold;">申通快递</span>、单号<span style="color:red;font-weight:bold;">st12654458855</span>；卖家应补<span style="color:red;font-weight:bold;">0</span>、买家应补<span style="color:red;font-weight:bold;">0</span>、应退运费<span style="color:red;font-weight:bold;">8</span>元；发货仓选择<span style="color:red;font-weight:bold;">淘金仓库</span>；备注：<span style="color:red;font-weight:bold;">破损补发</span>；<br>收件人信息：<span style="color:red;font-weight:bold;">陕西省西安市雁塔区丈八街道丹轩梓园3号楼，收货人朱小明、13800138000</span>，寄出快递选择京东快递，再点击<span style="color:red;font-weight:bold;">确定创建新售后单</span>。',
        fields: ({ form }) => [ORDER_FIELD, ...buildResendOrderFields(form)],
        tables: ({ ui }) => buildPracticeOrderTables('补', ui),
        hotspots: [{
          id: 'create-resend-aftersale', x: 0.91, y: 0.95, w: 0.07, h: 0.028, highlight: 'primary',
          guard: validateResendOrder,
          action: () => ({ set: { createdThirdAftersales: [SIMULATED_AFTERSALE] }, next: 'after-resend-list' })
        }]
      },
      {
        id: 'after-resend-list',
        image: SCENE_IMAGES.aftersaleList,
        aspectRatio: 2,
        tip: '普通售后业务－补发已创建。请继续点击<span style="color:red;font-weight:bold;">创建退货补发换货售后单</span>，创建<span style="color:red;font-weight:bold;">错发售后业务－普通退货</span>。',
        tables: context => buildAftersaleListTables(context),
        hotspots: [{
          id: 'create-wrong-return-aftersale', x: 0.17, y: 0.145, w: 0.10, h: 0.035, highlight: 'primary',
          setForm: { orderCode: '' },
          next: 'wrong-order-search'
        }]
      },
      {
        id: 'wrong-order-search',
        image: SCENE_IMAGES.empty,
        aspectRatio: 2,
        tip: '输入线上订单号 <span style="color:red;font-weight:bold;">' + TARGET_ORDER_CODE + '</span> 并点击搜索，进入错发售后建单。',
        fields: [ORDER_FIELD],
        hotspots: [{
          id: 'search-wrong-order', x: 0.657, y: 0.091, w: 0.03, h: 0.028, highlight: 'primary',
          guard: ({ form }) => String(form.orderCode || '').trim() === TARGET_ORDER_CODE
            ? { ok: true }
            : { ok: false, msg: '请输入正确的线上订单号 ' + TARGET_ORDER_CODE },
          set: CLEAR_PRACTICE_ORDER_SELECTION,
          next: 'wrong-normal-business'
        }]
      },
      {
        id: 'wrong-normal-business',
        image: SCENE_IMAGES.return,
        aspectRatio: 2,
        tip: '订单搜索完成，当前处于<span style="color:red;font-weight:bold;">普通售后业务</span>。请点击<span style="color:red;font-weight:bold;">错发售后业务</span>。',
        fields: [ORDER_FIELD],
        tables: ({ ui }) => buildPracticeOrderTables('退', ui),
        hotspots: [{
          id: 'enter-wrong-business', x: 0.095, y: 0.492, w: 0.053, h: 0.027, highlight: 'primary',
          guard: requirePracticeOrderSelection,
          next: 'create-wrong-return'
        }]
      },
      {
        id: 'create-wrong-return',
        image: SCENE_IMAGES.refund,
        aspectRatio: 2,
        tip: '已选择<span style="color:red;font-weight:bold;">错发售后业务－普通退货</span>。请勾选商品编码为<span style="color:red;font-weight:bold;">' + TARGET_PRACTICE_GOODS_CODE + '</span>的商品；填写买家退回快递<span style="color:red;font-weight:bold;">申通快递</span>、单号<span style="color:red;font-weight:bold;">st12654458855</span>，卖家应补<span style="color:red;font-weight:bold;">0</span>、买家应补<span style="color:red;font-weight:bold;">0</span>、应退运费<span style="color:red;font-weight:bold;">8</span>；退货仓选择<span style="color:red;font-weight:bold;">淘金仓库</span>，买家退款账号填写<span style="color:red;font-weight:bold;">13800138000</span>，卖家退款账号选择<span style="color:red;font-weight:bold;">淘金账户</span>，备注填写<span style="color:red;font-weight:bold;">错发退货退款</span>，再点击<span style="color:red;font-weight:bold;">确定创建新售后单</span>。',
        fields: [ORDER_FIELD, ...buildWrongReturnFields()],
        tables: ({ ui }) => buildWrongReturnOrderTables(ui),
        hotspots: [{
          id: 'add-wrong-return-sent-goods', x: 0.138, y: 0.685, w: 0.075, h: 0.026, highlight: 'primary',
          action: () => ({
            set: { wrongReturnLibrarySearched: false, 'wrong-return-library-tableSelectedKeys': [], 'wrong-return-library-tableSelectedRows': [] },
            setForm: { wrongReturnLibraryStyleCode: '' },
            next: 'select-wrong-return-sent-library-goods'
          })
        }, {
          id: 'confirm-create-wrong-return', x: 0.912, y: 0.945, w: 0.065, h: 0.03, highlight: 'primary',
          guard: validateWrongReturnCreation,
          action: ({ ui }) => ({
            set: {
              createdThirdAftersales: [...(ui.createdThirdAftersales || []), SIMULATED_WRONG_RETURN_AFTERSALE],
              wrongReturnAddedGoods: [],
              wrongReturnLibrarySearched: false,
              'wrong-return-library-tableSelectedKeys': [],
              'wrong-return-library-tableSelectedRows': [],
              'third-wrong-return-goods-tableSelectedKeys': [],
              'third-wrong-return-goods-tableSelectedRows': []
            },
            next: 'after-wrong-return-list'
          })
        }]
      },
      {
        id: 'after-wrong-return-list',
        image: SCENE_IMAGES.aftersaleList,
        aspectRatio: 2,
        tip: '错发售后业务－普通退货已创建。请继续点击<span style="color:red;font-weight:bold;">创建退货补发换货售后单</span>，开始创建<span style="color:red;font-weight:bold;">错发售后业务－换货</span>。',
        tables: context => buildAftersaleListTables(context),
        hotspots: [{
          id: 'create-wrong-exchange-aftersale', x: 0.17, y: 0.145, w: 0.10, h: 0.035, highlight: 'primary',
          setForm: { orderCode: '' },
          next: 'wrong-exchange-order-search'
        }]
      },
      {
        id: 'wrong-exchange-order-search',
        image: SCENE_IMAGES.empty,
        aspectRatio: 2,
        tip: '输入线上订单号 <span style="color:red;font-weight:bold;">' + TARGET_ORDER_CODE + '</span> 并点击搜索，创建错发售后业务－换货。',
        fields: [ORDER_FIELD],
        hotspots: [{
          id: 'search-wrong-exchange-order', x: 0.657, y: 0.091, w: 0.03, h: 0.028, highlight: 'primary',
          guard: ({ form }) => String(form.orderCode || '').trim() === TARGET_ORDER_CODE
            ? { ok: true }
            : { ok: false, msg: '请输入正确的线上订单号 ' + TARGET_ORDER_CODE },
          set: CLEAR_PRACTICE_ORDER_SELECTION,
          next: 'wrong-exchange-normal-business'
        }]
      },
      {
        id: 'wrong-exchange-normal-business',
        image: SCENE_IMAGES.return,
        aspectRatio: 2,
        tip: '订单搜索完成，当前处于<span style="color:red;font-weight:bold;">普通售后业务</span>。请点击<span style="color:red;font-weight:bold;">错发售后业务</span>。',
        fields: [ORDER_FIELD],
        tables: ({ ui }) => buildPracticeOrderTables('退', ui),
        hotspots: [{
          id: 'enter-wrong-exchange-business', x: 0.095, y: 0.492, w: 0.053, h: 0.027, highlight: 'primary',
          guard: requirePracticeOrderSelection,
          next: 'wrong-exchange-default-return'
        }]
      },
      {
        id: 'wrong-exchange-default-return',
        image: SCENE_IMAGES.refund,
        aspectRatio: 2,
        tip: '已进入<span style="color:red;font-weight:bold;">错发售后业务</span>，系统默认选中<span style="color:red;font-weight:bold;">普通退货</span>。请点击售后分类中的<span style="color:red;font-weight:bold;">换货</span>。',
        fields: [ORDER_FIELD],
        tables: ({ ui }) => buildWrongReturnOrderTables(ui),
        hotspots: [{
          id: 'wrong-exchange-type', x: 0.155, y: 0.526, w: 0.045, h: 0.027, highlight: 'primary', next: 'create-wrong-exchange'
        }]
      },
      {
        id: 'create-wrong-exchange',
        image: r('3-wrong-exchange.png'),
        aspectRatio: 2,
        tip: '<p><strong>订单信息</strong><br>退回快递：<span style="color:red;font-weight:bold;">申通快递</span>；单号：<span style="color:red;font-weight:bold;">st12654458855</span>；卖家应补：<span style="color:red;font-weight:bold;">0</span>；买家应补：<span style="color:red;font-weight:bold;">0</span>；应退运费：<span style="color:red;font-weight:bold;">8</span>。退货仓、收货仓、发货仓均选择<span style="color:red;font-weight:bold;">淘金仓库</span>；买家退款账号<span style="color:red;font-weight:bold;">13800138000</span>；卖家退款账号<span style="color:red;font-weight:bold;">淘金账户</span>。买家地址：<span style="color:red;font-weight:bold;">陕西省西安市雁塔区丈八街道丹轩梓园3号楼</span>，收货人<span style="color:red;font-weight:bold;">朱小明</span>，联系手机<span style="color:red;font-weight:bold;">13800138000</span>，寄出快递选择<span style="color:red;font-weight:bold;">京东快递</span>，备注<span style="color:red;font-weight:bold;">错发退换货</span>。</p><p><strong>操作一：标记应发未发商品</strong><br>点击<span style="color:red;font-weight:bold;">添加应发未发商品</span>，在弹窗中选中订单原商品 <span style="color:red;font-weight:bold;">' + TARGET_PRACTICE_GOODS_CODE + '</span>。</p><p><strong>操作二：添加错发已发商品</strong><br>在商品库中按款式编码搜索或直接选择 <span style="color:red;font-weight:bold;">' + TARGET_LIBRARY_STYLE_CODE + '</span>。</p><p><strong>操作三：点击添加换货的商品(订单)</strong><br>选择订单原商品 <span style="color:red;font-weight:bold;">' + TARGET_PRACTICE_GOODS_CODE + '</span>，确认后添加为换货商品。</p><p><strong>操作四：售后问题登记（图片／线下备注）</strong><br>选择<span style="color:red;font-weight:bold;">待客服处理</span>，点击<span style="color:red;font-weight:bold;">确定</span>保存并返回建单页。</p>',
        fields: ({ form }) => [ORDER_FIELD, ...buildWrongExchangeFields(form)],
        tables: ({ ui }) => buildWrongExchangeOrderTables(ui),
        hotspots: [{
          id: 'add-missing-order-goods', x: 0.052, y: 0.685, w: 0.075, h: 0.026, highlight: 'primary', next: 'select-missing-order-goods'
        }, {
          id: 'add-wrong-sent-goods', x: 0.138, y: 0.685, w: 0.075, h: 0.026, highlight: 'primary', next: 'select-wrong-sent-library-goods'
        }, {
          id: 'add-exchange-order-goods', x: 0.222, y: 0.685, w: 0.08, h: 0.026, highlight: 'primary', next: 'select-exchange-order-goods'
        }, {
          id: 'open-aftersale-issue-registration', x: 0.411, y: 0.685, w: 0.10, h: 0.026, highlight: 'primary', next: 'aftersale-issue-registration'
        }, {
          id: 'confirm-create-wrong-exchange', x: 0.91, y: 0.945, w: 0.065, h: 0.025, highlight: 'primary',
          guard: validateWrongExchangeCreation,
          action: ({ ui }) => ({ set: { createdThirdAftersales: [...(ui.createdThirdAftersales || []), SIMULATED_WRONG_EXCHANGE_AFTERSALE] }, next: 'after-wrong-exchange-list' })
        }]
      },
      {
        id: 'after-wrong-exchange-list',
        image: SCENE_IMAGES.aftersaleList,
        aspectRatio: 2,
        tip: '错发售后业务－换货已创建。请继续点击<span style="color:red;font-weight:bold;">创建退货补发换货售后单</span>，创建<span style="color:red;font-weight:bold;">漏发售后业务－补发</span>。',
        tables: context => buildAftersaleListTables(context),
        hotspots: [{
          id: 'create-leak-resend-aftersale', x: 0.17, y: 0.145, w: 0.10, h: 0.035, highlight: 'primary',
          setForm: {
            orderCode: '', returnExpress: '', returnWaybill: '', sellerSubsidy: '', buyerSubsidy: '', refundFreight: '', remark: '', shippingWarehouse: '',
            receiverProvince: '', receiverCity: '', receiverDistrict: '', receiverAddress: '', receiverName: '', receiverPhone: '', outExpress: ''
          },
          next: 'leak-order-search'
        }]
      },
      {
        id: 'aftersale-issue-registration',
        image: r('3-aftersale-issue-registration.png'),
        aspectRatio: 2,
        tip: '请选择<span style="color:red;font-weight:bold;">待客服处理</span>，点击<span style="color:red;font-weight:bold;">确定</span>保存并返回建单页。',
        labels: ({ ui }) => ui.wrongExchangeIssueRegistrationPending
          ? [{ id: 'issue-registration-pending-check', text: '✓', color: '#1687ff', fontWeight: 'bold', fontSize: 15, x: 0.494, y: 0.338, w: 0.012, h: 0.022 }]
          : [],
        hotspots: [{
          id: 'select-issue-registration-pending', x: 0.49, y: 0.337, w: 0.09, h: 0.03, highlight: 'primary',
          action: () => ({ set: { wrongExchangeIssueRegistrationPending: true } })
        }, {
          id: 'save-aftersale-issue-registration', x: 0.602, y: 0.823, w: 0.035, h: 0.032, highlight: 'primary',
          guard: ({ ui }) => ui.wrongExchangeIssueRegistrationPending
            ? { ok: true }
            : { ok: false, msg: '请先选择待客服处理。' },
          action: () => ({ set: { wrongExchangeIssueRegistrationCompleted: true }, next: 'create-wrong-exchange' })
        }, {
          id: 'close-aftersale-issue-registration', x: 0.625, y: 0.142, w: 0.012, h: 0.022,
          next: 'create-wrong-exchange'
        }]
      },
      {
        id: 'select-missing-order-goods',
        image: r('3-select-return-order-goods.png'),
        aspectRatio: 2,
        tip: '请选择<span style="color:red;font-weight:bold;">' + TARGET_PRACTICE_GOODS_CODE + '</span>。选择后会将该订单商品的明细问题类型改为<span style="color:red;font-weight:bold;">应发未发</span>。',
        tables: ({ ui }) => buildOrderGoodsPicker('wrong-exchange-missing-picker-table', ui['wrong-exchange-missing-picker-tableSelectedKeys'] || [], { x: 0.297, y: 0.3, w: 0.438, h: 0.4 }),
        hotspots: [{
          id: 'close-missing-order-goods-modal', x: 0.716, y: 0.267, w: 0.016, h: 0.025, next: 'create-wrong-exchange'
        }, {
          id: 'confirm-missing-order-goods', x: 0.628, y: 0.74, w: 0.1, h: 0.032, highlight: 'primary',
          guard: ({ ui }) => {
            const existingType = (ui.wrongExchangeOrderIssueTypes || {})['wrong-exchange-goods-1']
            const selectedMainRow = (ui['third-wrong-exchange-goods-tableSelectedRows'] || []).find(row => row.id === 'wrong-exchange-goods-1')
            const currentType = existingType || (selectedMainRow && selectedMainRow.issueType)
            if (currentType && currentType !== '应发未发') return { ok: false, msg: '该订单商品已经是其他明细问题类型，不能改为应发未发。' }
            if (ui.wrongExchangeAddedMissing) return { ok: false, msg: '该订单商品已设置为应发未发。' }
            const selected = (ui['wrong-exchange-missing-picker-tableSelectedRows'] || [])[0]
            return selected && selected.id === 'wrong-exchange-goods-1' ? { ok: true } : { ok: false, msg: '请选择商品编码 ' + TARGET_PRACTICE_GOODS_CODE + '。' }
          },
          action: ({ ui }) => ({
            set: {
              wrongExchangeAddedMissing: true,
              wrongExchangeOrderIssueTypes: { ...(ui.wrongExchangeOrderIssueTypes || {}), 'wrong-exchange-goods-1': '应发未发' },
              ...selectWrongExchangeGood(ui, { ...WRONG_EXCHANGE_GOODS[0], issueType: '应发未发' })
            },
            next: 'create-wrong-exchange'
          })
        }]
      },
      {
        id: 'select-wrong-return-sent-library-goods',
        image: r('3-product-library.png'),
        aspectRatio: 2,
        fields: [{ id: 'wrong-return-library-style-code', model: 'wrongReturnLibraryStyleCode', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '款式编码', x: 0.19, y: 0.1702, w: 0.04, h: 0.023 }],
        tables: context => buildWrongReturnProductLibraryTables(context),
        hotspots: [{
          id: 'close-wrong-return-library-modal', x: 0.795, y: 0.135, w: 0.016, h: 0.025, next: 'create-wrong-return'
        }, {
          id: 'search-wrong-return-library-style-code', x: 0.665, y: 0.202, w: 0.035, h: 0.028, highlight: 'primary',
          guard: ({ form }) => String(form.wrongReturnLibraryStyleCode || '').trim().toUpperCase() === WRONG_RETURN_LIBRARY_PRODUCT.styleCode
            ? { ok: true }
            : { ok: false, msg: '请使用款式编码 ' + WRONG_RETURN_LIBRARY_PRODUCT.styleCode + ' 搜索商品。' },
          set: { wrongReturnLibrarySearched: true, 'wrong-return-library-tableSelectedKeys': [], 'wrong-return-library-tableSelectedRows': [] }
        }, {
          id: 'confirm-wrong-return-library-goods', x: 0.761, y: 0.833, w: 0.045, h: 0.028, highlight: 'primary',
          guard: ({ ui }) => {
            if (!ui.wrongReturnLibrarySearched) return { ok: false, msg: '请先搜索款式编码 ' + WRONG_RETURN_LIBRARY_PRODUCT.styleCode + '。' }
            const selected = (ui['wrong-return-library-tableSelectedRows'] || [])[0]
            return selected && selected.id === WRONG_RETURN_LIBRARY_PRODUCT.id
              ? { ok: true }
              : { ok: false, msg: '请搜索并选中款式编码 ' + WRONG_RETURN_LIBRARY_PRODUCT.styleCode + ' 的商品。' }
          },
          action: () => ({
            set: {
              wrongReturnAddedGoods: [WRONG_RETURN_ADDED_GOOD],
              'wrong-return-library-tableSelectedKeys': [],
              'wrong-return-library-tableSelectedRows': []
            },
            next: 'create-wrong-return'
          })
        }]
      },
      {
        id: 'select-wrong-sent-library-goods',
        image: r('3-product-library.png'),
        aspectRatio: 2,
        tip: '商品库默认展示全部商品。请用款式编码搜索<span style="color:red;font-weight:bold;">' + TARGET_LIBRARY_STYLE_CODE + '</span>，选中不在订单中的商品后确认返回。',
        fields: [{ id: 'library-style-code', model: 'libraryStyleCode', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '款式编码', x: 0.19, y: 0.1702, w: 0.04, h: 0.023 }],
        tables: context => buildProductLibraryTables(context),
        hotspots: [{
          id: 'close-wrong-sent-library-modal', x: 0.795, y: 0.135, w: 0.016, h: 0.025, next: 'create-wrong-exchange'
        }, {
          id: 'search-library-style-code', x: 0.665, y: 0.202, w: 0.035, h: 0.028, highlight: 'primary',
          guard: ({ form }) => String(form.libraryStyleCode || '').trim().toUpperCase() === TARGET_LIBRARY_STYLE_CODE.toUpperCase()
            ? { ok: true }
            : { ok: false, msg: '请使用款式编码 ' + TARGET_LIBRARY_STYLE_CODE + ' 搜索商品。' }
        }, {
          id: 'confirm-wrong-sent-library-goods', x: 0.761, y: 0.833, w: 0.045, h: 0.028, highlight: 'primary',
          guard: ({ ui }) => {
            const selected = (ui['wrong-exchange-library-tableSelectedRows'] || [])[0]
            return selected && selected.id === TARGET_LIBRARY_GOODS.id
              ? { ok: true }
              : { ok: false, msg: '请搜索并选中款式编码 ' + TARGET_LIBRARY_STYLE_CODE + ' 的商品。' }
          },
          action: ({ ui }) => ({
            set: { wrongExchangeAddedWrong: true, ...appendWrongExchangeGood(ui, { id: 'added-wrong-sent-goods-1', thumbnail: '', goodsCode: TARGET_LIBRARY_GOODS_CODE, styleCode: TARGET_LIBRARY_STYLE_CODE, type: '退', issueType: '错发已发', goodsName: TARGET_LIBRARY_GOODS.goodsName, spec: TARGET_LIBRARY_GOODS.spec, orderGoodsStatus: '', goodsTag: '', unitPrice: TARGET_LIBRARY_GOODS.unitPrice, goodsAmount: TARGET_LIBRARY_GOODS.unitPrice, orderQty: 1, currentQty: '1', defectiveQty: '', currentAmount: TARGET_LIBRARY_GOODS.unitPrice, appliedReturnQty: 0, actualReturnQty: 0, remark: '', availableStock: TARGET_LIBRARY_GOODS.stock }) },
            next: 'create-wrong-exchange'
          })
        }]
      },
      {
        id: 'select-exchange-order-goods',
        image: r('3-select-exchange-order-goods.png'),
        aspectRatio: 2,
        tip: '请选择订单原商品中的<span style="color:red;font-weight:bold;">' + TARGET_PRACTICE_GOODS_CODE + '</span>，确认后将其添加为<span style="color:red;font-weight:bold;">换货</span>商品。',
        tables: ({ ui }) => buildOrderGoodsPicker('wrong-exchange-order-picker-table', ui['wrong-exchange-order-picker-tableSelectedKeys'] || [], { x: 0.296, y: 0.3, w: 0.44, h: 0.4 }),
        hotspots: [{
          id: 'close-exchange-order-goods-modal', x: 0.716, y: 0.267, w: 0.016, h: 0.025, next: 'create-wrong-exchange'
        }, {
          id: 'confirm-exchange-order-goods', x: 0.628, y: 0.738, w: 0.105, h: 0.032, highlight: 'primary',
          guard: ({ ui }) => {
            const selected = (ui['wrong-exchange-order-picker-tableSelectedRows'] || [])[0]
            return selected && selected.id === 'wrong-exchange-goods-1' ? { ok: true } : { ok: false, msg: '请选择商品编码 ' + TARGET_PRACTICE_GOODS_CODE + '。' }
          },
          action: ({ ui }) => ({
            set: { wrongExchangeAddedExchange: true, ...appendWrongExchangeGood(ui, { ...WRONG_EXCHANGE_GOODS[0], id: 'added-exchange-goods-1', type: '换', issueType: '', currentQty: '0' }) },
            next: 'create-wrong-exchange'
          })
        }]
      },
      {
        id: 'aftersale-detail',
        image: SCENE_IMAGES.detail,
        aspectRatio: 2,
        tip: '已进入<span style="color:red;font-weight:bold;">订单售后明细</span>。查看线上订单号<span style="color:red;font-weight:bold;">' + TARGET_ORDER_CODE + '</span>的售后单号、商品、申请数量和退款金额。',
        fields: [ORDER_FIELD],
        tables: ({ ui }) => [
          buildPracticeOrderTables('退', ui, DETAIL_PRACTICE_ORDER)[0],
          ...buildOrderAftersaleDetailTables()
        ],
        isEnd: true
      },
      {
        id: 'create-noinfo',
        image: SCENE_IMAGES.noInfo,
        aspectRatio: 2,
        tip: '<p><strong>快递信息</strong><br>买家退回快递填写<span style="color:red;font-weight:bold;">申通快递</span>；买家退回快递单号填写<span style="color:red;font-weight:bold;">st12654458855</span>。</p><p><strong>基础信息</strong><br>备注填写<span style="color:red;font-weight:bold;">无信息件退货</span>；退货仓选择<span style="color:red;font-weight:bold;">淘金仓库</span>；店铺选择<span style="color:red;font-weight:bold;">淘金云官方旗舰店</span>。</p><p><strong>下一步</strong><br>完成上述信息后，点击<span style="color:red;font-weight:bold;">添加退回来的商品（商品库）</span>。</p>',
        fields: buildNoInfoFields(),
        tables: ({ ui }) => buildNoInfoCreateGoodsTables(ui),
        hotspots: ({ ui }) => [{
          id: 'add-return-goods', x: 0.235, y: 0.418, w: 0.105, h: 0.024, highlight: 'primary', next: 'select-noinfo-goods'
        }, ...((ui.noinfoAddedGoods || []).length ? [{
          id: 'confirm-create-noinfo-aftersale', x: 0.731, y: 0.742, w: 0.06, h: 0.028, highlight: 'primary',
          guard: validateNoInfoCreation,
          action: ({ ui }) => ({ set: { createdThirdAftersales: [...(ui.createdThirdAftersales || []), SIMULATED_NOINFO_AFTERSALE] }, next: 'after-noinfo-list' })
        }] : [])]
      },
      {
        id: 'after-noinfo-list',
        image: SCENE_IMAGES.aftersaleList,
        aspectRatio: 2,
        tip: '无信息件售后单已创建。继续点击<span style="color:red;font-weight:bold;">创建退货补发换货售后单</span>，查看订单售后明细。',
        tables: context => buildAftersaleListTables(context),
        hotspots: [{
          id: 'create-aftersale-detail', x: 0.17, y: 0.145, w: 0.10, h: 0.035, highlight: 'primary',
          setForm: { orderCode: '' },
          next: 'detail-order-search'
        }]
      },
      {
        id: 'detail-order-search',
        image: SCENE_IMAGES.empty,
        aspectRatio: 2,
        tip: '输入线上订单号<span style="color:red;font-weight:bold;">' + TARGET_ORDER_CODE + '</span>并点击搜索，查看该订单的售后明细。',
        fields: [ORDER_FIELD],
        hotspots: [{
          id: 'search-detail-order', x: 0.657, y: 0.091, w: 0.03, h: 0.028, highlight: 'primary',
          guard: ({ form }) => String(form.orderCode || '').trim() === DETAIL_ORDER_CODE
            ? { ok: true }
            : { ok: false, msg: '请输入正确的线上订单号 ' + DETAIL_ORDER_CODE },
          set: CLEAR_PRACTICE_ORDER_SELECTION,
          next: 'detail-order-result'
        }]
      },
      {
        id: 'detail-order-result',
        image: SCENE_IMAGES.return,
        aspectRatio: 2,
        tip: '订单查询成功。点击<span style="color:red;font-weight:bold;">订单售后明细</span>查看线上订单号<span style="color:red;font-weight:bold;">' + TARGET_ORDER_CODE + '</span>的售后明细。',
        fields: [ORDER_FIELD],
        tables: ({ ui }) => buildPracticeOrderTables('退', ui, DETAIL_PRACTICE_ORDER),
        hotspots: [{
          id: 'view-order-aftersale-detail', x: 0.20, y: 0.485, w: 0.05, h: 0.03, highlight: 'primary',
          guard: requirePracticeOrderSelection,
          next: 'aftersale-detail'
        }]
      },
      {
        id: 'select-noinfo-goods',
        image: SCENE_IMAGES.goods,
        aspectRatio: 2,
        tip: '请在商品编码中搜索<span style="color:red;font-weight:bold;">' + TARGET_LIBRARY_STYLE_CODE + '</span>，选中搜索结果后点击<span style="color:red;font-weight:bold;">确定返回</span>。',
        fields: [{
          id: 'goods-code', model: 'goodsCode', type: 'text', bgColor: '#fff', fontSize: 11,
          placeholder: '商品编码', x: 0.23, y: 0.171, w: 0.04, h: 0.022
        }],
        tables: context => buildNoInfoProductLibraryTables(context),
        hotspots: [{
          id: 'search-noinfo-goods', x: 0.665, y: 0.202, w: 0.035, h: 0.028, highlight: 'primary',
          guard: ({ form }) => String(form.goodsCode || '').trim().toUpperCase() === TARGET_LIBRARY_STYLE_CODE.toUpperCase()
            ? { ok: true }
            : { ok: false, msg: '请在商品编码中输入 ' + TARGET_LIBRARY_STYLE_CODE + ' 后搜索。' },
          action: ({ form }) => ({ set: { noinfoSearchedGoodsCode: String(form.goodsCode || '').trim() } })
        }, {
          id: 'confirm-goods', x: 0.761, y: 0.838, w: 0.05, h: 0.03, highlight: 'primary',
          guard: ({ ui }) => {
            const selected = (ui['noinfo-product-library-tableSelectedRows'] || [])[0]
            return selected && selected.id === TARGET_LIBRARY_GOODS.id
              ? { ok: true }
              : { ok: false, msg: '请选择款式编码为 ' + TARGET_LIBRARY_STYLE_CODE + ' 的商品。' }
          },
          action: () => ({ set: { noinfoAddedGoods: SIMULATED_NOINFO_AFTERSALE_GOODS }, next: 'create-noinfo' })
        }]
      },
      {
        id: 'done',
        image: SCENE_IMAGES.aftersaleList,
        aspectRatio: 2,
        tables: context => buildAftersaleListTables(context),
        tip: '<span style="color:red;font-weight:bold;">第三章创建售后练习完成。</span>',
        isEnd: true
      }
    ]
  }
  return {
    ...scenario,
    steps: scenario.steps.map(step => ({ ...step, tip: getThirdChapterTip }))
  }
}



// WEBPACK FOOTER //
// ./src/page/simulate/jushuitan/jstErpCreateAftersaleScenarios.js